module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.30114",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4926",
      "atom": "static-1.5282",
      "conversations-error-reporting": "static-1.9093",
      "conversations-internal-pub-sub": "static-1.16189",
      "conversations-internal-schema": "static-1.13262",
      "conversations-message-history": "static-1.13321",
      "conversations-test-sdk": "static-1.10707",
      "conversations-visitor-experience-components": "static-1.23477",
      "data-fetching-client": "static-1.9863",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5799",
      "hs-test-utils": "static-1.8230",
      "hubspot-dlb": "static-2.1854",
      "HubStyleTokens": "static-2.11680",
      "I18n": "static-7.1650",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.3227",
      "jasmine-runner": "static-1.6660",
      "quartz": "static-1.7303",
      "react-dlb": "static-1.83",
      "react-select-plus": "static-1.108",
      "react-transition-group": "static-2.68",
      "redux-thunk": "static-2.43",
      "reselect": "static-3.8",
      "sanitize": "static-1.4683",
      "StyleGuideUI": "static-3.491",
      "transmute": "static-2.85",
      "urlinator": "static-1.4738",
      "usage-tracker": "static-1.7557",
      "usage-tracker-core": "static-1.7407",
      "usage-tracker-public": "static-1.7368",
      "viral-links-lib": "static-1.7276",
      "visitor-ui-component-library": "static-1.6349",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5020",
      "conversations-prop-types": "static-1.7660",
      "conversations-visitor-message-history": "static-1.22214",
      "cssUtils": "static-1.853",
      "enviro": "static-4.455",
      "flux-actions": "static-1.355",
      "foundations-components": "static-1.8314",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6423",
      "hubspot-url-utils": "static-1.4132",
      "immutable": "static-2.79",
      "metrics-js": "static-1.9637",
      "PatternValidationJS": "static-1.3103",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "react": "static-7.189",
      "react-aria": "static-1.69",
      "react-dom": "static-7.85",
      "react-redux": "static-7.71",
      "react-rhumb": "static-1.16910",
      "react-utils": "static-2.5484",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "sanitize-text": "static-1.8352",
      "signup-constants": "static-1.19381",
      "styled-components": "static-2.89",
      "usage-tracker-multi": "static-1.5971",
      "visitor-ui-component-library-icons": "static-1.6160",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3543",
      "moment": "static-3.26",
      "quartz-config": "static-1.1081",
      "quartz-core": "static-1.6522",
      "foundations-assets": "static-1.5081",
      "foundations-theming": "static-1.4649",
      "UIComponents": "static-3.8626",
      "conversations-async-data": "static-2.7872",
      "customer-data-email": "static-1.18394",
      "cv-backend-services": "static-1.1589",
      "immutable-less": "static-1.4856",
      "conversations-skeleton-state": "static-1.7453",
      "crm-events-viz-core": "static-1.33789",
      "customer-data-objects": "static-1.7888",
      "icons": "static-2.668",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.760",
      "rpc-client-utils": "static-1.4864",
      "ui-images": "static-2.1214",
      "apollo-stack-hubspot": "static-3.89",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.85",
      "HeadJS": "static-2.781",
      "framer-motion": "static-1.75",
      "hs-test-utils-bend-plugin": "static-1.3341",
      "msw": "static-1.39",
      "testing-library": "static-1.155",
      "i18n-data": "static-1.225",
      "moment-timezone": "static-5.86",
      "jasmine": "static-4.4529",
      "signup-ui-url-generator": "static-2.8263",
      "HubStyle": "static-2.11987",
      "quartz-i18n": "static-1.978",
      "sassPrefix": "static-1.160",
      "bend-plugin-foundations-components": "static-1.4583",
      "floating-ui": "static-1.60",
      "foundations-theming-specialty": "static-1.2365",
      "hs-story-utils": "static-1.9631",
      "react-create-root-preference": "static-1.50",
      "react-virtualized": "static-2.102",
      "tanstack-table": "static-1.58",
      "trellis-assets": "static-1.2348",
      "ui-fonts": "static-1.942",
      "hs-locale-management": "static-1.224",
      "csstype": "static-1.50",
      "quartz-head": "static-1.968",
      "quick-fetch": "static-1.4060",
      "web-vitals": "static-1.9",
      "quartz-routing": "static-1.733",
      "usage-tracker-anonymous": "static-1.5974",
      "bender-build-tools": "static-1.3323",
      "dispatcher": "static-1.140",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.858",
      "hubspotter-http": "static-1.4794",
      "mobile-manifest-mixins": "static-1.555",
      "module-federation": "static-1.29",
      "quartz-auth": "static-1.978",
      "quartz-test": "static-1.978",
      "quartz-tracking": "static-1.682",
      "trellis-components": "static-1.2367",
      "usage-tracker-container": "static-1.7547",
      "bend-plugin-foundations-theming": "static-1.3132",
      "foundations-theming-base": "static-1.3634",
      "stylex": "static-1.37",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4860",
      "customer-data-ui-utilities": "static-1.10030",
      "FileManagerCore": "static-1.39724",
      "FileManagerLib": "static-1.39865",
      "hubspot-apollo-client": "static-1.5083",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.529",
      "timezone-utils": "static-2.5450",
      "ui-gdpr-components": "static-1.10556",
      "ts-schema": "static-1.4223",
      "ai-components-ui-library": "static-1.9468",
      "avatar-components": "static-1.2703",
      "content-assistance-lib": "static-1.8064",
      "crm-component-utils": "static-1.39634",
      "crm-display-components": "static-1.25384",
      "crm-fe-perf": "static-1.23107",
      "crm-links": "static-1.6523",
      "crm-message-bus": "static-1.43550",
      "crm-search-service-types": "static-1.1361",
      "crm-source-interpretation-lib": "static-1.5539",
      "customer-data-communicator": "static-1.46103",
      "customer-data-filters-ui": "static-1.40576",
      "customer-data-objects-ui-components": "static-1.13237",
      "customer-data-properties": "static-1.52282",
      "customer-data-rte": "static-1.33484",
      "draft-plugins": "static-2.22024",
      "file-manager-components": "static-1.24225",
      "trellis-theming": "static-1.1159",
      "framework-data-schema-resolvers": "static-1.7100",
      "frontend-preferences-client": "static-1.8132",
      "hubspot-prosemirror": "static-1.18808",
      "object-comments-thread-lib": "static-1.11175",
      "prosemirror-user-and-team-at-mentions": "static-1.1040",
      "reference-resolvers-lite": "static-1.8302",
      "ui-addon-upgrades": "static-9.18266",
      "universal-associations-select": "static-1.11274",
      "universal-record-utils-lib": "static-1.1559",
      "wootric-nps": "static-1.7125",
      "inbound-db-properties-service-client": "static-1.3988",
      "property-translator": "static-1.5601",
      "segments-query-core": "static-1.1627",
      "bend-plugin-chirp-manifest": "static-1.274",
      "chirp-fetch": "static-1.2093",
      "hub-http-shared-msw-handlers": "static-1.10451",
      "hubspotter-http-shared-msw-handlers": "static-1.10449",
      "usage-tracker-session-replay": "static-1.5243",
      "base-ui": "static-1.17",
      "react-day-picker": "static-1.6",
      "tanstack-virtual": "static-1.33",
      "react-dnd-compat": "static-1.4820",
      "audio-components": "static-1.6215",
      "ContentUtils": "static-1.68952",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29668",
      "FileManagerImages": "static-1.37376",
      "foundations-components-legacy": "static-1.1339",
      "html-to-image": "static-1.57",
      "immerable": "static-1.4354",
      "react-colorpicker": "static-2.10415",
      "ui-universal-auth": "static-1.9225",
      "video-components": "static-1.13930",
      "video-data-lib": "static-1.35586",
      "video-embed": "static-1.36420",
      "hubspot-apollo-cache": "static-1.542",
      "chatspot-core": "static-1.22351",
      "copilot-toolkit": "static-1.11654",
      "superstore": "static-1.4964",
      "ui-addon-video-player": "static-1.8912",
      "ui-coaching-tips": "static-1.29120",
      "card-properties-lib": "static-1.44804",
      "commerce-subscription-lib": "static-1.37601",
      "crm-actions": "static-1.6556",
      "crm-cards-sdk": "static-1.44233",
      "customer-data-properties-shared-msw-handlers": "static-1.9778",
      "customer-data-property-utils": "static-1.8301",
      "customer-data-tracking": "static-1.7090",
      "hs-resources": "static-1.385",
      "inbound-db-meta-service-client": "static-1.3718",
      "pulse": "static-1.822",
      "framework-data-table": "static-2.12366",
      "location-customization-utils-lib": "static-1.9877",
      "restore-request-side-panel-lib": "static-1.1414",
      "calling-error-reporting": "static-1.31527",
      "calling-internal-common": "static-1.31520",
      "calling-usage-tracker": "static-1.6746",
      "crm_data": "static-4.92615",
      "customer-data-content": "static-1.27667",
      "draft-content-plugins": "static-1.28751",
      "draft-convert": "static-2.76",
      "draft-extend": "static-3.79",
      "draft-js": "static-5.81",
      "draft-signature-plugin": "static-1.24554",
      "EmailSignatureEditor": "static-1.24834",
      "hubspot-prosemirror-plugins": "static-1.18800",
      "integration-settings-components": "static-1.16024",
      "integrations-lib": "static-1.16793",
      "integrations-tracking-lib": "static-1.5813",
      "native-integrations-shared-strings": "static-1.7983",
      "nav-meta": "static-1.30241",
      "onboarding-scopes": "static-1.6664",
      "outreach-assistant-email-generation": "static-1.6658",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12120",
      "quotes-client-types": "static-1.38731",
      "reference-resolvers": "static-1.8383",
      "rich-text-lib": "static-1.20177",
      "sales-email-signature-service-client": "static-1.4049",
      "sequences-lib": "static-1.8391",
      "ui-addon-i18n": "static-1.11353",
      "ui-addon-iframeable": "static-1.9280",
      "ui-business-units-lib": "static-1.9286",
      "ui-shepherd-react": "static-3.10467",
      "user-context": "static-1.5317",
      "whatsapp-sending-lib": "static-1.6476",
      "customer-data-filters-ui-msw-helpers": "static-1.23011",
      "customer-data-reference-ui-components": "static-1.13382",
      "events-data-lib": "static-1.444",
      "FormUrlGenerator": "static-2.4929",
      "framework-builder-read-service-client": "static-1.4149",
      "framework-data-schema-quick-fetch": "static-1.7005",
      "multi-account-reference-resolvers": "static-1.1188",
      "onboarding-tours": "static-1.16976",
      "reporting-datasets-permissions-lib": "static-1.14260",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21807",
      "batch-promise": "static-1.1750",
      "calling-global-api": "static-1.65198",
      "calling-lifecycle-internal": "static-1.66580",
      "calling-lifecycle-messages": "static-1.58874",
      "commerce-products-lib": "static-1.10286",
      "conditional-properties-service-client": "static-1.3940",
      "crm-index-visualization-core": "static-1.4407",
      "crm-pipelines-api-client-types": "static-1.4280",
      "external-options-client-types": "static-1.4269",
      "formula-editor": "static-1.14610",
      "google-libphonenumber": "static-1.41",
      "inbounddb-objects-service-types": "static-1.4359",
      "meetings-icalendar-utils-lib": "static-1.837",
      "multi-currency-client-types": "static-1.3834",
      "object-builder-ui-client": "static-1.49405",
      "pipeline-validation-client-types": "static-1.4109",
      "property-value-citations": "static-1.2896",
      "smart-property-lib": "static-1.8099",
      "tiered-pricing": "static-1.1777",
      "topics-actions-lib": "static-1.361",
      "ui-addon-form-validation": "static-1.11194",
      "zustand": "static-1.79",
      "breeze-engine-lib": "static-1.1437",
      "video-components-external": "static-1.11928",
      "fdsr-migration-layer": "static-1.219",
      "persist-promise": "static-1.3907",
      "content-media-capture": "static-1.5171",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25969",
      "knowledge-content-types": "static-1.8597",
      "payment-link-components": "static-1.23982",
      "ui-addon-emoji-picker": "static-1.10091",
      "call-summary": "static-1.39888",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10597",
      "laboratory-lib": "static-3.7357",
      "merchandise-lib": "static-1.269",
      "purchase-motions-components": "static-1.6221",
      "crm-object-search-query-utilities": "static-1.10024",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "cms-field-types": "static-1.5021",
      "content-icons-ui": "static-1.2289",
      "underscore": "static-1.8",
      "unified-auth-core-lib": "static-1.1021",
      "social-insights-client-types": "static-1.22598",
      "outpost": "static-1.4371",
      "markdown-it": "static-1.6",
      "magpie-lib": "static-1.5697",
      "magpie-types": "static-1.5157",
      "simple-logging-lib": "static-1.3255",
      "growth-onboarding-feedback-components": "static-1.6787",
      "customer-data-sidebar": "static-2.46559",
      "enrichment-properties-lib": "static-1.17537",
      "ui-addon-draggable-compat": "static-2.4464",
      "commerce-billing-lib": "static-1.19786",
      "commerce-shared-components-lib": "static-1.19041",
      "commerce-tools-ui-lib": "static-1.10878",
      "event-emitter": "static-1.1156",
      "bend-plugin-pulse": "static-1.325",
      "fast-json-patch": "static-1.66",
      "customer-data-associations": "static-1.7538",
      "reporting-data": "static-1.68375",
      "ui-addon-draggable": "static-3.4960",
      "crm-record-cards-service-types": "static-1.3727",
      "crm_universal": "static-1.22364",
      "SalesContentIndexUI": "static-3.9515",
      "content-embed-lib": "static-1.7543",
      "data-model-builder-lib": "static-1.12921",
      "remote-ui": "static-1.68",
      "ui-components-test-utils": "static-1.5817",
      "ui-extensions-remote-renderer": "static-1.17618",
      "universal-page-editor-lib": "static-1.3217",
      "integrations-error-boundary-lib": "static-1.14208",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10571",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.739",
      "messaging-types-lib": "static-1.46668",
      "ai-addon-copilot-preview": "static-1.8680",
      "copilot-plugins": "static-1.11626",
      "data-token-picker": "static-1.16758",
      "sequences-client-types-lib": "static-1.8248",
      "foundations-components-test-utils": "static-1.5797",
      "navigation-messaging": "static-1.7931",
      "getting-started-shared-tasks": "static-1.19003",
      "getting-started-shared-tasks-store": "static-1.18121",
      "onboarding-tours-utils": "static-1.1042",
      "messaging-usage-based-billing-components-lib": "static-1.1793",
      "whatsapp-management-lib": "static-1.9635",
      "growth-data-modal": "static-1.5756",
      "growth-onboarding-confetti": "static-1.3266",
      "growth-onboarding-next-action-utils": "static-1.2501",
      "navigation-components": "static-1.18604",
      "onboarding-tours-client": "static-1.5190",
      "ui-shepherd-tracker": "static-1.7848",
      "shared-worker-versioning": "static-1.11243",
      "voice-sms-access-library": "static-1.1727",
      "commerce-permissions": "static-1.982",
      "products-iframe-lib": "static-1.8410",
      "products-ui-components-shared-msw-handlers": "static-1.10833",
      "crm-index-associations-lib": "static-1.6647",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10534",
      "sales-views-client-types": "static-1.4462",
      "bark-lib": "static-1.16702",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.98",
      "crm-properties-common-lib": "static-1.6093",
      "react-codemirror": "static-1.10846",
      "data-agent-kit": "static-1.510",
      "fsm": "static-1.3938",
      "policy-lib": "static-1.6994",
      "react-tinymce": "static-1.55780",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54906",
      "tinymce-plugins": "static-1.58020",
      "tinymce-themes": "static-1.56876",
      "breeze-engine-chat-components": "static-1.415",
      "breeze-engine-core": "static-1.715",
      "highlight.js": "static-1.82",
      "content-media-composition-data-lib": "static-1.12975",
      "content-media-compositions": "static-2.16982",
      "idb-keyval": "static-1.47",
      "media-bridge-lib": "static-1.19274",
      "fix-webm-duration": "static-1.26",
      "notification-sounds": "static-1.4631",
      "seat-types-lib": "static-1.472",
      "ui-addon-opt": "static-4.8566",
      "commerce-tours-lib": "static-1.6472",
      "growth-onboarding-reliability": "static-1.5288",
      "sales-checkout-service-client": "static-1.3743",
      "calling-cross-tab-library": "static-1.19494",
      "calling-lifecycle-usage-tracker": "static-1.9227",
      "purchase-motions-api": "static-1.6224",
      "reactive-lib": "static-1.928",
      "card-payment-highlight-lib": "static-1.37770",
      "card-subscription-highlight-lib": "static-1.40024",
      "commerce-contract-lib": "static-1.12993",
      "invoices-highlight-card-lib": "static-1.55394",
      "orders-highlight-card-lib": "static-1.22003",
      "products-highlight-card-lib": "static-1.18569",
      "quotes-highlight-card-lib": "static-1.72641",
      "usage-based-billing-components-lib": "static-1.9837",
      "utility-belt": "static-1.2737",
      "payments-enrollment-embed-lib": "static-1.23601",
      "stripe-embedded-components": "static-1.7863",
      "growth-onboarding-empty-states": "static-1.6127",
      "InboxConnectUtils": "static-4.15361",
      "payments-post-enroll-local-storage-lib": "static-1.5311",
      "qrcode-generator": "static-1.72",
      "reporting-client-types": "static-1.2629",
      "react-flip-move": "static-1.74",
      "FireAlarmUi": "static-1.4651",
      "sales-templates-service-types-lib": "static-1.4311",
      "ui-asset-management-lib": "static-1.11291",
      "association-settings-lib": "static-1.10828",
      "collaboration-sidebar": "static-1.58496",
      "conditional-property-settings-modal": "static-1.12882",
      "data-model-commons-lib": "static-1.13190",
      "ExportDialog": "static-6.10584",
      "final-form": "static-1.73",
      "nudge-client-utils": "static-1.2998",
      "object-definition-builder-lib": "static-1.7310",
      "property-management-iframe": "static-1.13834",
      "property-usages-lib": "static-1.5661",
      "reactflow": "static-1.67",
      "simple-data-table": "static-1.3348",
      "used-in-list-lib": "static-1.7165",
      "visual-association": "static-1.6096",
      "highcharts": "static-8.107",
      "reporting-visualizations": "static-1.60451",
      "ui-extensibility-client-types": "static-1.4128",
      "adobe-sign-auth-lib": "static-1.255",
      "ads-unified-auth-lib": "static-1.780",
      "google-sheets-integration-lib": "static-1.832",
      "microsoft-drive-integration-lib": "static-1.942",
      "surveymonkey-integration-lib": "static-1.277",
      "slack-ui-library": "static-1.10605",
      "automation-platform-service-types": "static-1.2640",
      "ContentData": "static-1.69027",
      "email-portal-health-service-types": "static-1.1183",
      "marketing-email-service-types": "static-1.2046",
      "ai-rendering-library": "static-1.10892",
      "ai-settings-ui-library": "static-1.8195",
      "ui-brand-identity-lib": "static-1.16027",
      "messaging-shared-utils-lib": "static-1.1242",
      "messaging-user-info-utils-lib": "static-1.1412",
      "content-whatsapp-service-types": "static-1.508",
      "marketing-platform-lib": "static-1.7073",
      "short-messages-app-service-client": "static-1.4124",
      "ui-tool-access": "static-1.10358",
      "onboarding-data-sync-lib": "static-1.2318",
      "growth-onboarding-next-action-components": "static-1.2529",
      "user-context-client": "static-1.4754",
      "nest": "static-1.442",
      "calling-orchestration-schema": "static-1.36504",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16159",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4713",
      "storybook-react": "static-1.36",
      "hub-http-contrib": "static-1.3247",
      "interframe": "static-3.4961",
      "tinymce-data": "static-1.40991",
      "ui-addon-sales-email": "static-1.5418",
      "layout-dnd-components": "static-1.12828",
      "layout-dnd-utils": "static-1.11803",
      "NamespacedHubStyle": "static-2.9193",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.40804",
      "accounting-integrations-ui-components": "static-1.7402",
      "invoices-ui-lib": "static-1.55410",
      "commerce-products-api": "static-1.2588",
      "invoices-iframe-lib": "static-1.57468",
      "quotes-modal-lib": "static-1.103319",
      "quotes-ui-lib": "static-1.81362",
      "platform-infra-nav-components": "static-1.7814",
      "reporting-ui-components": "static-2.65646",
      "subscription-experience-data-types": "static-1.15157",
      "marketplace-ui-apps-core": "static-1.18953",
      "stripe-connect-js": "static-1.73",
      "ui-addon-react-router-dom": "static-1.9739",
      "nested-table": "static-1.443",
      "chatspot-widget-iframe": "static-1.22342",
      "collaboration-sidebar-common": "static-1.3293",
      "nudge-custom-function-registry": "static-1.2755",
      "nudge-renderer-utils": "static-1.3074",
      "whisper-core-api": "static-1.7125",
      "property-management-common": "static-1.6122",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15453",
      "advanced-menus-lib": "static-1.12345",
      "ui-memberships-settings-lib": "static-1.34612",
      "breeze-onboarding-components": "static-1.516",
      "embedded-academy-lib": "static-1.15109",
      "mermaid": "static-1.3",
      "reporting-action-components": "static-1.41813",
      "reporting-snowflake": "static-1.56993",
      "upgrade-components-lib": "static-1.406",
      "meetings-connect-utils-lib": "static-1.7811",
      "layout-data-lib": "static-1.10128",
      "commerce-tax-lib": "static-1.743",
      "price-books-api": "static-1.1511",
      "price-books-components": "static-1.1569",
      "property-description-translator": "static-1.4045",
      "ramp-editor": "static-1.711",
      "commerce-analytics-service-client": "static-1.3731",
      "totals-ui-components": "static-1.24124",
      "reporting-plugins": "static-1.10653",
      "reporting-reports": "static-1.68053",
      "edison-service-client-types": "static-1.592",
      "developer-experience-shared-components": "static-1.10707",
      "marketplace-ui-client-types": "static-1.17828",
      "marketplace-ui-common": "static-1.20421",
      "ui-addon-integrations-directory-panel": "static-2.8228",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.379",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15452",
      "simple-menus-lib": "static-1.16969",
      "onboarding-journeys-lib": "static-1.635",
      "academy-common-lib": "static-1.14569",
      "dashboard-lib": "static-1.82345",
      "share-with-third-party-component-lib": "static-1.8908",
      "line-items-api": "static-1.986",
      "commerce-totals-service-types": "static-1.3958",
      "campaign-roi-lib": "static-1.9844",
      "ui-addon-calendars": "static-2.5529",
      "apps-service-types": "static-1.3973",
      "oauth-service-types": "static-1.4459",
      "ui-product-approvals-common": "static-1.789",
      "academy-service-client": "static-1.3893",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4610",
      "trellis-ecosystem": "static-1.7491",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.30114",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4926",
      "atom": "/atom/static-1.5282",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9093",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16189",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13262",
      "conversations-message-history": "/conversations-message-history/static-1.13321",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10707",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.23477",
      "data-fetching-client": "/data-fetching-client/static-1.9863",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5799",
      "hs-test-utils": "/hs-test-utils/static-1.8230",
      "hubspot-dlb": "/hubspot-dlb/static-2.1854",
      "HubStyleTokens": "/HubStyleTokens/static-2.11680",
      "I18n": "/I18n/static-7.1650",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.3227",
      "jasmine-runner": "/jasmine-runner/static-1.6660",
      "quartz": "/quartz/static-1.7303",
      "react-dlb": "/react-dlb/static-1.83",
      "react-select-plus": "/react-select-plus/static-1.108",
      "react-transition-group": "/react-transition-group/static-2.68",
      "redux-thunk": "/redux-thunk/static-2.43",
      "reselect": "/reselect/static-3.8",
      "sanitize": "/sanitize/static-1.4683",
      "StyleGuideUI": "/StyleGuideUI/static-3.491",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4738",
      "usage-tracker": "/usage-tracker/static-1.7557",
      "usage-tracker-core": "/usage-tracker-core/static-1.7407",
      "usage-tracker-public": "/usage-tracker-public/static-1.7368",
      "viral-links-lib": "/viral-links-lib/static-1.7276",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6349",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5020",
      "conversations-prop-types": "/conversations-prop-types/static-1.7660",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.22214",
      "cssUtils": "/cssUtils/static-1.853",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.355",
      "foundations-components": "/foundations-components/static-1.8314",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6423",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
      "immutable": "/immutable/static-2.79",
      "metrics-js": "/metrics-js/static-1.9637",
      "PatternValidationJS": "/PatternValidationJS/static-1.3103",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.189",
      "react-aria": "/react-aria/static-1.69",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.71",
      "react-rhumb": "/react-rhumb/static-1.16910",
      "react-utils": "/react-utils/static-2.5484",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "sanitize-text": "/sanitize-text/static-1.8352",
      "signup-constants": "/signup-constants/static-1.19381",
      "styled-components": "/styled-components/static-2.89",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5971",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6160",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3543",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.1081",
      "quartz-core": "/quartz-core/static-1.6522",
      "foundations-assets": "/foundations-assets/static-1.5081",
      "foundations-theming": "/foundations-theming/static-1.4649",
      "UIComponents": "/UIComponents/static-3.8626",
      "conversations-async-data": "/conversations-async-data/static-2.7872",
      "customer-data-email": "/customer-data-email/static-1.18394",
      "cv-backend-services": "/cv-backend-services/static-1.1589",
      "immutable-less": "/immutable-less/static-1.4856",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7453",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33789",
      "customer-data-objects": "/customer-data-objects/static-1.7888",
      "icons": "/icons/static-2.668",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.760",
      "rpc-client-utils": "/rpc-client-utils/static-1.4864",
      "ui-images": "/ui-images/static-2.1214",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.85",
      "HeadJS": "/HeadJS/static-2.781",
      "framer-motion": "/framer-motion/static-1.75",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3341",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.155",
      "i18n-data": "/i18n-data/static-1.225",
      "moment-timezone": "/moment-timezone/static-5.86",
      "jasmine": "/jasmine/static-4.4529",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8263",
      "HubStyle": "/HubStyle/static-2.11987",
      "quartz-i18n": "/quartz-i18n/static-1.978",
      "sassPrefix": "/sassPrefix/static-1.160",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4583",
      "floating-ui": "/floating-ui/static-1.60",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2365",
      "hs-story-utils": "/hs-story-utils/static-1.9631",
      "react-create-root-preference": "/react-create-root-preference/static-1.50",
      "react-virtualized": "/react-virtualized/static-2.102",
      "tanstack-table": "/tanstack-table/static-1.58",
      "trellis-assets": "/trellis-assets/static-1.2348",
      "ui-fonts": "/ui-fonts/static-1.942",
      "hs-locale-management": "/hs-locale-management/static-1.224",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.968",
      "quick-fetch": "/quick-fetch/static-1.4060",
      "web-vitals": "/web-vitals/static-1.9",
      "quartz-routing": "/quartz-routing/static-1.733",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5974",
      "bender-build-tools": "/bender-build-tools/static-1.3323",
      "dispatcher": "/dispatcher/static-1.140",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.858",
      "hubspotter-http": "/hubspotter-http/static-1.4794",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.555",
      "module-federation": "/module-federation/static-1.29",
      "quartz-auth": "/quartz-auth/static-1.978",
      "quartz-test": "/quartz-test/static-1.978",
      "quartz-tracking": "/quartz-tracking/static-1.682",
      "trellis-components": "/trellis-components/static-1.2367",
      "usage-tracker-container": "/usage-tracker-container/static-1.7547",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3132",
      "foundations-theming-base": "/foundations-theming-base/static-1.3634",
      "stylex": "/stylex/static-1.37",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4860",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10030",
      "FileManagerCore": "/FileManagerCore/static-1.39724",
      "FileManagerLib": "/FileManagerLib/static-1.39865",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5083",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.529",
      "timezone-utils": "/timezone-utils/static-2.5450",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10556",
      "ts-schema": "/ts-schema/static-1.4223",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9468",
      "avatar-components": "/avatar-components/static-1.2703",
      "content-assistance-lib": "/content-assistance-lib/static-1.8064",
      "crm-component-utils": "/crm-component-utils/static-1.39634",
      "crm-display-components": "/crm-display-components/static-1.25384",
      "crm-fe-perf": "/crm-fe-perf/static-1.23107",
      "crm-links": "/crm-links/static-1.6523",
      "crm-message-bus": "/crm-message-bus/static-1.43550",
      "crm-search-service-types": "/crm-search-service-types/static-1.1361",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5539",
      "customer-data-communicator": "/customer-data-communicator/static-1.46103",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40576",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13237",
      "customer-data-properties": "/customer-data-properties/static-1.52282",
      "customer-data-rte": "/customer-data-rte/static-1.33484",
      "draft-plugins": "/draft-plugins/static-2.22024",
      "file-manager-components": "/file-manager-components/static-1.24225",
      "trellis-theming": "/trellis-theming/static-1.1159",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7100",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8132",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18808",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11175",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1040",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8302",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18266",
      "universal-associations-select": "/universal-associations-select/static-1.11274",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1559",
      "wootric-nps": "/wootric-nps/static-1.7125",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3988",
      "property-translator": "/property-translator/static-1.5601",
      "segments-query-core": "/segments-query-core/static-1.1627",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.274",
      "chirp-fetch": "/chirp-fetch/static-1.2093",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10451",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10449",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5243",
      "base-ui": "/base-ui/static-1.17",
      "react-day-picker": "/react-day-picker/static-1.6",
      "tanstack-virtual": "/tanstack-virtual/static-1.33",
      "react-dnd-compat": "/react-dnd-compat/static-1.4820",
      "audio-components": "/audio-components/static-1.6215",
      "ContentUtils": "/ContentUtils/static-1.68952",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29668",
      "FileManagerImages": "/FileManagerImages/static-1.37376",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1339",
      "html-to-image": "/html-to-image/static-1.57",
      "immerable": "/immerable/static-1.4354",
      "react-colorpicker": "/react-colorpicker/static-2.10415",
      "ui-universal-auth": "/ui-universal-auth/static-1.9225",
      "video-components": "/video-components/static-1.13930",
      "video-data-lib": "/video-data-lib/static-1.35586",
      "video-embed": "/video-embed/static-1.36420",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.542",
      "chatspot-core": "/chatspot-core/static-1.22351",
      "copilot-toolkit": "/copilot-toolkit/static-1.11654",
      "superstore": "/superstore/static-1.4964",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8912",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29120",
      "card-properties-lib": "/card-properties-lib/static-1.44804",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37601",
      "crm-actions": "/crm-actions/static-1.6556",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44233",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9778",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8301",
      "customer-data-tracking": "/customer-data-tracking/static-1.7090",
      "hs-resources": "/hs-resources/static-1.385",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "pulse": "/pulse/static-1.822",
      "framework-data-table": "/framework-data-table/static-2.12366",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9877",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1414",
      "calling-error-reporting": "/calling-error-reporting/static-1.31527",
      "calling-internal-common": "/calling-internal-common/static-1.31520",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6746",
      "crm_data": "/crm_data/static-4.92615",
      "customer-data-content": "/customer-data-content/static-1.27667",
      "draft-content-plugins": "/draft-content-plugins/static-1.28751",
      "draft-convert": "/draft-convert/static-2.76",
      "draft-extend": "/draft-extend/static-3.79",
      "draft-js": "/draft-js/static-5.81",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24554",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24834",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18800",
      "integration-settings-components": "/integration-settings-components/static-1.16024",
      "integrations-lib": "/integrations-lib/static-1.16793",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5813",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7983",
      "nav-meta": "/nav-meta/static-1.30241",
      "onboarding-scopes": "/onboarding-scopes/static-1.6664",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6658",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12120",
      "quotes-client-types": "/quotes-client-types/static-1.38731",
      "reference-resolvers": "/reference-resolvers/static-1.8383",
      "rich-text-lib": "/rich-text-lib/static-1.20177",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4049",
      "sequences-lib": "/sequences-lib/static-1.8391",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11353",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9280",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9286",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10467",
      "user-context": "/user-context/static-1.5317",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.6476",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23011",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13382",
      "events-data-lib": "/events-data-lib/static-1.444",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4929",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4149",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7005",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1188",
      "onboarding-tours": "/onboarding-tours/static-1.16976",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14260",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21807",
      "batch-promise": "/batch-promise/static-1.1750",
      "calling-global-api": "/calling-global-api/static-1.65198",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66580",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58874",
      "commerce-products-lib": "/commerce-products-lib/static-1.10286",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3940",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4407",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4280",
      "external-options-client-types": "/external-options-client-types/static-1.4269",
      "formula-editor": "/formula-editor/static-1.14610",
      "google-libphonenumber": "/google-libphonenumber/static-1.41",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4359",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.837",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3834",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49405",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4109",
      "property-value-citations": "/property-value-citations/static-1.2896",
      "smart-property-lib": "/smart-property-lib/static-1.8099",
      "tiered-pricing": "/tiered-pricing/static-1.1777",
      "topics-actions-lib": "/topics-actions-lib/static-1.361",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11194",
      "zustand": "/zustand/static-1.79",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1437",
      "video-components-external": "/video-components-external/static-1.11928",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.219",
      "persist-promise": "/persist-promise/static-1.3907",
      "content-media-capture": "/content-media-capture/static-1.5171",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25969",
      "knowledge-content-types": "/knowledge-content-types/static-1.8597",
      "payment-link-components": "/payment-link-components/static-1.23982",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10091",
      "call-summary": "/call-summary/static-1.39888",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10597",
      "laboratory-lib": "/laboratory-lib/static-3.7357",
      "merchandise-lib": "/merchandise-lib/static-1.269",
      "purchase-motions-components": "/purchase-motions-components/static-1.6221",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10024",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "cms-field-types": "/cms-field-types/static-1.5021",
      "content-icons-ui": "/content-icons-ui/static-1.2289",
      "underscore": "/underscore/static-1.8",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1021",
      "social-insights-client-types": "/social-insights-client-types/static-1.22598",
      "outpost": "/outpost/static-1.4371",
      "markdown-it": "/markdown-it/static-1.6",
      "magpie-lib": "/magpie-lib/static-1.5697",
      "magpie-types": "/magpie-types/static-1.5157",
      "simple-logging-lib": "/simple-logging-lib/static-1.3255",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6787",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46559",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17537",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4464",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.19786",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19041",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10878",
      "event-emitter": "/event-emitter/static-1.1156",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.325",
      "fast-json-patch": "/fast-json-patch/static-1.66",
      "customer-data-associations": "/customer-data-associations/static-1.7538",
      "reporting-data": "/reporting-data/static-1.68375",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4960",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3727",
      "crm_universal": "/crm_universal/static-1.22364",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9515",
      "content-embed-lib": "/content-embed-lib/static-1.7543",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12921",
      "remote-ui": "/remote-ui/static-1.68",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5817",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17618",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3217",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14208",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10571",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.739",
      "messaging-types-lib": "/messaging-types-lib/static-1.46668",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8680",
      "copilot-plugins": "/copilot-plugins/static-1.11626",
      "data-token-picker": "/data-token-picker/static-1.16758",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8248",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5797",
      "navigation-messaging": "/navigation-messaging/static-1.7931",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19003",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18121",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1042",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1793",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.9635",
      "growth-data-modal": "/growth-data-modal/static-1.5756",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3266",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2501",
      "navigation-components": "/navigation-components/static-1.18604",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5190",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7848",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11243",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.1727",
      "commerce-permissions": "/commerce-permissions/static-1.982",
      "products-iframe-lib": "/products-iframe-lib/static-1.8410",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10833",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6647",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10534",
      "sales-views-client-types": "/sales-views-client-types/static-1.4462",
      "bark-lib": "/bark-lib/static-1.16702",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.98",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6093",
      "react-codemirror": "/react-codemirror/static-1.10846",
      "data-agent-kit": "/data-agent-kit/static-1.510",
      "fsm": "/fsm/static-1.3938",
      "policy-lib": "/policy-lib/static-1.6994",
      "react-tinymce": "/react-tinymce/static-1.55780",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54906",
      "tinymce-plugins": "/tinymce-plugins/static-1.58020",
      "tinymce-themes": "/tinymce-themes/static-1.56876",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.415",
      "breeze-engine-core": "/breeze-engine-core/static-1.715",
      "highlight.js": "/highlight.js/static-1.82",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12975",
      "content-media-compositions": "/content-media-compositions/static-2.16982",
      "idb-keyval": "/idb-keyval/static-1.47",
      "media-bridge-lib": "/media-bridge-lib/static-1.19274",
      "fix-webm-duration": "/fix-webm-duration/static-1.26",
      "notification-sounds": "/notification-sounds/static-1.4631",
      "seat-types-lib": "/seat-types-lib/static-1.472",
      "ui-addon-opt": "/ui-addon-opt/static-4.8566",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6472",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5288",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19494",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9227",
      "purchase-motions-api": "/purchase-motions-api/static-1.6224",
      "reactive-lib": "/reactive-lib/static-1.928",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37770",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40024",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.12993",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55394",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22003",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18569",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72641",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9837",
      "utility-belt": "/utility-belt/static-1.2737",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23601",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7863",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6127",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15361",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5311",
      "qrcode-generator": "/qrcode-generator/static-1.72",
      "reporting-client-types": "/reporting-client-types/static-1.2629",
      "react-flip-move": "/react-flip-move/static-1.74",
      "FireAlarmUi": "/FireAlarmUi/static-1.4651",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4311",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11291",
      "association-settings-lib": "/association-settings-lib/static-1.10828",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58496",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12882",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13190",
      "ExportDialog": "/ExportDialog/static-6.10584",
      "final-form": "/final-form/static-1.73",
      "nudge-client-utils": "/nudge-client-utils/static-1.2998",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7310",
      "property-management-iframe": "/property-management-iframe/static-1.13834",
      "property-usages-lib": "/property-usages-lib/static-1.5661",
      "reactflow": "/reactflow/static-1.67",
      "simple-data-table": "/simple-data-table/static-1.3348",
      "used-in-list-lib": "/used-in-list-lib/static-1.7165",
      "visual-association": "/visual-association/static-1.6096",
      "highcharts": "/highcharts/static-8.107",
      "reporting-visualizations": "/reporting-visualizations/static-1.60451",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4128",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.255",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.780",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.832",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.942",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.277",
      "slack-ui-library": "/slack-ui-library/static-1.10605",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2640",
      "ContentData": "/ContentData/static-1.69027",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1183",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.2046",
      "ai-rendering-library": "/ai-rendering-library/static-1.10892",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8195",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16027",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1242",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1412",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.508",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7073",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4124",
      "ui-tool-access": "/ui-tool-access/static-1.10358",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2318",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2529",
      "user-context-client": "/user-context-client/static-1.4754",
      "nest": "/nest/static-1.442",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36504",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16159",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4713",
      "storybook-react": "/storybook-react/static-1.36",
      "hub-http-contrib": "/hub-http-contrib/static-1.3247",
      "interframe": "/interframe/static-3.4961",
      "tinymce-data": "/tinymce-data/static-1.40991",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5418",
      "layout-dnd-components": "/layout-dnd-components/static-1.12828",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11803",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9193",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.40804",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7402",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.55410",
      "commerce-products-api": "/commerce-products-api/static-1.2588",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57468",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103319",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81362",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7814",
      "reporting-ui-components": "/reporting-ui-components/static-2.65646",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15157",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18953",
      "stripe-connect-js": "/stripe-connect-js/static-1.73",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9739",
      "nested-table": "/nested-table/static-1.443",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22342",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3293",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2755",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3074",
      "whisper-core-api": "/whisper-core-api/static-1.7125",
      "property-management-common": "/property-management-common/static-1.6122",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15453",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12345",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34612",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.516",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15109",
      "mermaid": "/mermaid/static-1.3",
      "reporting-action-components": "/reporting-action-components/static-1.41813",
      "reporting-snowflake": "/reporting-snowflake/static-1.56993",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.406",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7811",
      "layout-data-lib": "/layout-data-lib/static-1.10128",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.743",
      "price-books-api": "/price-books-api/static-1.1511",
      "price-books-components": "/price-books-components/static-1.1569",
      "property-description-translator": "/property-description-translator/static-1.4045",
      "ramp-editor": "/ramp-editor/static-1.711",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3731",
      "totals-ui-components": "/totals-ui-components/static-1.24124",
      "reporting-plugins": "/reporting-plugins/static-1.10653",
      "reporting-reports": "/reporting-reports/static-1.68053",
      "edison-service-client-types": "/edison-service-client-types/static-1.592",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10707",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17828",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20421",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8228",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.379",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15452",
      "simple-menus-lib": "/simple-menus-lib/static-1.16969",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.635",
      "academy-common-lib": "/academy-common-lib/static-1.14569",
      "dashboard-lib": "/dashboard-lib/static-1.82345",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8908",
      "line-items-api": "/line-items-api/static-1.986",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3958",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.9844",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5529",
      "apps-service-types": "/apps-service-types/static-1.3973",
      "oauth-service-types": "/oauth-service-types/static-1.4459",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.789",
      "academy-service-client": "/academy-service-client/static-1.3893",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4610",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7491",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.30114",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};